<template>
  <div v-show="isLoaded" class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/reviews/publications">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.name}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Редактирование отзыва</p>
          </div>
          <div class="column">
            <div class="content">
              <div class="article-name">
                <span class="article-name-caption">Статья</span>
                <p class="article-name-value">{{article.title}}</p>
                <a target="_blank" v-if="article.path" :href="article.path" class="article-name-path">{{article.path}}</a>
              </div>
              <new-input title="ID статьи" name="parent_id"></new-input>
              <calendar name="created_at" title="Дата создания"></calendar>
              <new-input title="Имя автора" name="name"></new-input>
              <edit-file class="short align-top" use-case="cover" v-if="isLoaded" title="Изображение"
                         name="img"/>
              <new-text-area title="Отзыв" name="message"></new-text-area>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'
  import Calendar from '../../../../edit-form/Calendar'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data: function () {
      return {
        ckeditor: null,
        text: '',
        article: {}
      }
    },
    computed: {
      ...mapState([
        'isLoaded',
        'item',
        'copyItem',
        'textContent'
      ]),
      apiUrls() {
        return this.$store.state.apiUrls
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset'
      ]),
      ...mapMutations([
        'resetModule',
        'setFileExtensions',
        'setItemField'
      ]),
      onSubmit() {
        this.edit({
          name: this.item.name,
          created_at: this.item.created_at,
          parent_id: this.item.parent_id,
          img: this.item.img,
          message: this.item.message
        })
      },
      getSection(article) {
          if (article) {
              if (article.date_end) {
                  let itemDate = new Date(article.date_end)
                  if (!(itemDate > new Date && article.bool)) {
                      return 'video-otchoty'
                  }
              }
              if (this.$store.state.pagesUrl.hasOwnProperty(article.content_id)) {
                return this.$store.state.pagesUrl[article.content_id]
              } else {
                return this.$store.state.pagesUrl[article.parent_id]
              }
          } else {
              return 'no-url'
          }
      },
      setArticlePath() {
        let parentType = 'content_id'
        for (let url in this.$store.state.pagesUrl) {
          if (this.article.parent_id == url) {
            parentType = 'parent_id'
          }
          if (this.article[parentType] == url) {
            if (this.article[parentType] !== 97 && this.article[parentType] !== 5) {
              this.article.path = `${this.$store.state.siteDomainProd}/${this.getSection(this.article)}/${this.article.url}`
            } else {
              this.$http.get(`${this.$store.state.apiUrls.content}/${this.article.parent_id}`)
              .then(categoryRaw => {
                this.$set(this.article, 'path', `${this.$store.state.siteDomainProd}/${this.getSection(this.article)}/${categoryRaw.data.data.url}/${this.article.url}`)
              })
            }
          }
        }
      }
    },
    mounted() {
    },
    created() {
      this.resetModule();
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Отзывы в публикациях',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование отзыва',
        },
        errors: {
          name: {message: 'Введите имя автора', hasError: false},
          created_at: {message: 'Выберите дату создания', hasError: false},
          parent_id: {message: 'Введите ID статьи', hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', hasError: false},
          message: {message: 'Введите текст отзыва', hasError: false},
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.feedback
      }).then(() => {
        this.setItemField({fieldName: 'created_at', value: this.item.created_at.split(' ')[0]})
        this.$http.get(`${this.$store.state.apiUrls.content}/${this.item.parent_id}`)
        .then(article => {
          this.article = article.data.data
          this.setArticlePath()
        })
      })
    },
    components: {
      Calendar,
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload
    }
  }
</script>
<style lang="scss" scoped>
  .article-name {
    margin-bottom: 20px;

    &-caption {
      color: #6e7074;
    }

    &-value {
      word-break: break-all;
      word-break: break-word;
      color: #6e7074;
      font-size: 17px !important;
      font-weight: 500;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/reviews/publications/pages/Edit.vue